export enum RecurringEventsType {
  Daily = "Daily",
  Weekdays = "Weekdays",
  Weekly = "Weekly",
  EveryTwoWeeks = "Every two weeks",
  Monthly = "Monthly",

  Custom = "Custom"
}

export enum RecurringRepeatType {
  Day = "Day",
  Week = "Week",
  Month = "Month"
}

export enum RecurringRepeatOnNumber {
  First = "First",
  Second = "Second",
  Third = "Third",
  Fourth = "Fourth",
  Last = "Last"
}

export enum RecurringRepeatOnDay {
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
  Sunday = "Sunday"
}